import { VALID_LANGUAGES } from "@default/js/i18n/use-i18n";

export const objectToArray = (object) => {
  return Object.keys(object).map((key) => object[key]);
};

/**
 * Resolve current language from www.drupal.org/project/decoupled_router.
 *
 * @see src/js/client.jsx
 * @ses src/js/admin-app.jsx
 * @see src/js/server.js
 *
 * @param pathName string
 * @returns {string}
 */
export const getCurrentLanguage = (pathName) => {
  // Only a leading path segment is a language prefix, e.g. "/en" or "/en/...".
  // Matching anywhere in the path (e.g. "/helga/en") produced bogus languages
  // like "he" and thus invalid GraphQL endpoints.
  const match = pathName.match(
    new RegExp(`^/(${VALID_LANGUAGES.join("|")})(/|$)`)
  );

  return match ? match[1] : "und";
};
